import { Trans, useLingui } from '@lingui/react/macro';

const TOGGLE_BASE =
  'vai-px-4 vai-py-2 vai-text-sm vai-font-medium vai-transition-colors';
const TOGGLE_INACTIVE = 'vai-bg-white vai-text-gray-700 hover:vai-bg-gray-50';
const TOGGLE_ACTIVE = 'vai-bg-sapphire-50 vai-text-primary';
const TOGGLE_DIVIDER = 'vai-border-r vai-border-r-[1px] vai-border-base-input';

export type PlanSummaryView = 'dental-care' | 'orthodontics';

interface PlanSummaryViewToggleProps {
  value: PlanSummaryView;
  onChange: (view: PlanSummaryView) => void;
}

export const PlanSummaryViewToggle = ({
  value,
  onChange,
}: PlanSummaryViewToggleProps) => {
  const { t } = useLingui();

  return (
    <div
      className="vai-inline-flex vai-rounded-lg vai-overflow-hidden vai-border vai-border-gray-200 vai-border-[1px]"
      role="group"
      aria-label={t`Summary view`}
    >
      <button
        type="button"
        onClick={() => onChange('dental-care')}
        className={`${TOGGLE_BASE} vai-rounded-l-md ${TOGGLE_DIVIDER} ${
          value === 'dental-care' ? TOGGLE_ACTIVE : TOGGLE_INACTIVE
        }`}
        aria-pressed={value === 'dental-care'}
      >
        <Trans>Dental Care</Trans>
      </button>
      <button
        type="button"
        onClick={() => onChange('orthodontics')}
        className={`${TOGGLE_BASE} vai-rounded-r-md ${
          value === 'orthodontics' ? TOGGLE_ACTIVE : TOGGLE_INACTIVE
        }`}
        aria-pressed={value === 'orthodontics'}
      >
        <Trans>Orthodontics</Trans>
      </button>
    </div>
  );
};
